import { useMutation, useQueryClient } from '@tanstack/react-query';
import API from '../../../../context/API';
import { requireActiveStoreId } from '../../../../utils/activeStore';
import { notification } from '../../../../commonComponents/Notification/Notification';
import { CustomizationSoldOutItem } from '../types';
import { QUERY_KEYS } from '../constants';

export function useMarkCustomizationAvailable() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (item: CustomizationSoldOutItem) => {
      requireActiveStoreId();
      return API.put(`/customizations/${item.id}/rules`, {
        max_quantity: item.max_quantity || 0,
        min_quantity: item.min_quantity || 0,
        multiple_selections: item.multiple_selections || false,
        multiple_selections_quantity: item.multiple_selections_quantity || 0,
        sold_out: false,
        note: item.note || '',
      });
    },
    onSuccess: () => {
      notification.success(
        'Customization status updated',
        'The customization is now available.',
        5
      );
    },
    onError: () => {
      notification.error('An error occurred.', 'Unable to update the customization status.', 5);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.SOLD_OUT_CUSTOMIZATIONS] });
    },
  });
}
